import { intlLocale } from '../i18n.js';

/** 🇩🇪 from "DE". */
export const flagOf = (cc: string) =>
  String.fromCodePoint(...[...cc.toUpperCase()].map((c) => 0x1f1a5 + c.charCodeAt(0)));

/** "Deutschland" from "DE" in the app language; the code when the browser cannot name it. */
export function regionName(cc: string, language: string) {
  try {
    return new Intl.DisplayNames([intlLocale(language)], { type: 'region' }).of(cc) ?? cc;
  } catch {
    return cc;
  }
}
